import React from 'react';

import { useChipSelectionState } from './useChipSelectionState';
import type { SelectableChipProps } from './SelectableChip';
import { ChipSelectionClickHandler, useChipSelectionInteractions } from './useChipSelectionInteractions';

/**
 * Behaviour wrapper for selectable chips whose repeat click deselects them again,
 * closing their popup (e.g. the due-date chip).
 */
const ToggleChip: React.FC<SelectableChipProps> = ({ chip, canModify, onDelete, children }) => {
    const { isSelected, canSelect, isEditing, select, deselect, setEditing } = useChipSelectionState({
        chip,
        canModify,
    });

    const handleClick: ChipSelectionClickHandler = (event, focusChip) => {
        if (isSelected) {
            event.stopPropagation();
            deselect();
            return;
        }
        if (!canSelect) return;

        select();
        focusChip();
    };

    const { chipRef, chipProps } = useChipSelectionInteractions({
        isSelected,
        canActivate: canSelect,
        onClick: handleClick,
        onDeselect: deselect,
        onDelete: canModify ? onDelete : undefined,
        onEditingToggle: () => setEditing(!isEditing),
    });

    return <>{children({ isSelected, canActivate: canSelect, isEditing, setEditing, deselect, chipRef, chipProps })}</>;
};

export default ToggleChip;
